module.exports = __webpack_public_path__ + "media/open-sans/OpenSans-BoldItalic-d2f5b427.eot";